import React from 'react';

import {formatDate} from "utils";
import {CollapsableContainer} from "components/CollapsableContainer";
import {dayLabels, HygienistBackendJob, Requirements, Basis, Positions} from "components/EditJob";

import {
  Description,
  JobDetailsContainer,
  JobDetailsItem,
  JobDetailsItemContent,
  JobDetailsItemTitle,
  StyledAssignmentOutlinedIcon,
  StyledEventOutlinedIcon,
  StyledSchoolOutlinedIcon,
  StyledViewWeekOutlinedIcon,
  StyledWorkOutlineIcon
} from "components/JobInfo/JobInfo.styles";

interface JobInfoProps {
  job: HygienistBackendJob
}

const JobInfo = ({job}: JobInfoProps) => {
  return (
    <>
      <CollapsableContainer title='Job Details' defaultIsOpen={true}>
        <JobDetailsContainer>
          <JobDetailsItem>
            <StyledWorkOutlineIcon />
            <JobDetailsItemContent>
              <JobDetailsItemTitle>
                Role
              </JobDetailsItemTitle>
              <div>{(Positions.find(({ id }) => id === job.jobType) || {}).text}</div>
            </JobDetailsItemContent>
          </JobDetailsItem>
          <JobDetailsItem>
            <StyledAssignmentOutlinedIcon />
            <JobDetailsItemContent>
              <JobDetailsItemTitle>
                Contract
              </JobDetailsItemTitle>
              <div>{(Basis.find(({ id }) => id === job.basis) || {}).text}</div>
            </JobDetailsItemContent>
          </JobDetailsItem>
        </JobDetailsContainer>
        <JobDetailsContainer>
          <JobDetailsItem>
            <StyledEventOutlinedIcon />
            <JobDetailsItemContent>
              <JobDetailsItemTitle>
                Start Date
              </JobDetailsItemTitle>
              <div>{job.startDate ? formatDate(job.startDate) : null}</div>
            </JobDetailsItemContent>
          </JobDetailsItem>
          <JobDetailsItem>
            <StyledViewWeekOutlinedIcon />
            <JobDetailsItemContent>
              <JobDetailsItemTitle>
                Days Needed
              </JobDetailsItemTitle>
              <div>{(job.daysOfWeek.split(',').map(d => +d) || []).reduce((acc, day, index) => {
                if (day === 1) {
                  return `${acc.length ? `${acc} / ${dayLabels[index]}` : dayLabels[index]}`;
                } else {
                  return acc;
                }
              }, '')}</div>
            </JobDetailsItemContent>
          </JobDetailsItem>
        </JobDetailsContainer>
        <JobDetailsContainer>
          <JobDetailsItem>
            <StyledSchoolOutlinedIcon />
            <JobDetailsItemContent>
              <JobDetailsItemTitle>
                Minimum Experience
              </JobDetailsItemTitle>
              <div>{(Requirements.find(({ id }) => id === job.minYearsExp) || {}).text}</div>
            </JobDetailsItemContent>
          </JobDetailsItem>
        </JobDetailsContainer>
      </CollapsableContainer>
      <CollapsableContainer title='Job Description' defaultIsOpen={true}>
        <Description>{job.description}</Description>
      </CollapsableContainer>
    </>
  );
}

export default JobInfo;
